import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";
import { TextField, Typography, Button, Box } from "@mui/material";
import { SelectA, NumberFieldA, DatePickerA } from "./form";
import { FieldA } from "./form";
import { set } from "lodash";
import dayjs from "dayjs";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import TableSkeletonRows from "./table-skeleton-rows";

export const Grid = ({
  grouped,
  groupedColumns,
  columns,
  data,
  actions,
  map,
  pagination,
  filter,
  onSelectChange,
  isSelectEnabled,
  setStaticSelectedRows,
  staticSelectedRows,
  isLoading = false, // loading state
}) => {
  const [selected, setSelected] = React.useState([]);

  const [opens, setOpens] = React.useState(new Array(data.length).fill(false));

  // this useeffect will call onSelectChange with the selected but guess what
  // every time data changes, selected is set to empty array []
  // and do you know what onSelectChange does
  // it passes the current selected which is an empty array to the parent function and set their selected to empty array
  React.useEffect(() => {
    if (onSelectChange) {
      onSelectChange(selected);
    }
  }, [selected]);

  // everytime there is new data which will happen when initial load
  // but also when there is a pagination click
  // selected becomes zero because go to the use effect above
  React.useEffect(() => {
    setSelected([]);
  }, [data]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = data.map((n) => n);
      setSelected(newSelected);

      if (onSelectChange) {
        onSelectChange(newSelected);
      }

      // we need to go through the data and add it the staticSelectedRows map
      // these logic should only be done when staticSelectedRows is provided
      if (staticSelectedRows) {
        let newMap = new Map(staticSelectedRows);
        newSelected.forEach((s) => {
          newMap.set(s._id, s);
        });
        setStaticSelectedRows(newMap);
      }

      return;
    }

    // logic will be different for static selection ofrows
    // we just slice the data.length from the selected array
    // and set it to the selected array
    // from the end of the array

    // checkpoint here means that none is selected from the table
    // so we compare each data and check if it contains in the map and remove it
    let newMap = new Map(staticSelectedRows);
    data.forEach((d) => {
      if (newMap.has(d._id)) {
        newMap.delete(d._id);
      }
    });

    if (staticSelectedRows && setStaticSelectedRows) {
      setStaticSelectedRows(newMap);
    }

    setSelected([]);
    if (onSelectChange) {
      onSelectChange([]);
    }
  };

  const handleClick = (event, id, row) => {
    // check if the row is already selected by going check the map staticSelectedRows
    // if it is already selected then remove it from the map
    // else add it to the map
    // only do this when staticSelectedRows is provided
    if (staticSelectedRows) {
      if (staticSelectedRows.has(id)) {
        let newMap = new Map(staticSelectedRows);
        newMap.delete(id);
        setStaticSelectedRows(newMap);
      } else {
        staticSelectedRows.set(row._id, row);
        setStaticSelectedRows(staticSelectedRows);
      }
    }

    const selectedIndex = selected.map((n) => n._id).indexOf(id);
    let newSelected = [];
    console.log(newSelected, "newSelected");
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, row);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
    if (onSelectChange) {
      onSelectChange(newSelected);
    }
  };
  const isSelected = (id) => selected.map((n) => n._id).indexOf(id) !== -1;

  // modification of isSelected
  const isSelectedInMap = (id) =>
    staticSelectedRows ? staticSelectedRows.has(id) : -1;

  const {
    rowsPerPage,
    page,
    onPageChange,
    onRowsPerPageChange,
    rowsPerPageOptions,
    count,
  } = pagination || {};

  // console.log(filter, 'filter for tabel');

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", height: "100%" }}>
      <TableContainer
        sx={{ maxHeight: 650, maxHeight: "calc(100vh - 313px)" }}
      >
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead sx={{ boxShadow: 2 }}>
            <TableRow>
              {isSelectEnabled === false ? null : (
                <TableCell
                  padding="checkbox"
                  key={"checkbox-heads"}>
                  <Checkbox
                    color="primary"
                    // indeterminate={numSelected > 0 && numSelected < rowCount}
                    // checked={rowCount > 0 && numSelected === rowCount}
                    onChange={handleSelectAllClick}
                    inputProps={{
                      "aria-label": "select all desserts",
                    }}
                  />
                </TableCell>
              )}
              {grouped && <TableCell></TableCell>}

              {columns.map((column, i) => (
                <TableCell
                  key={i}
                  align={column.align}
                  sx={{
                    minWidth: column.minWidth ? column.minWidth : 150,
                    fontWeight: "bold",
                    width: column.width,
                    py: 1
                  }}
                >
                  {column?.editable && (
                    <FieldA
                      field={column.field}
                      data={column.data}
                      onChange={column.onChange}
                      state={column.state}
                      sxx={{ mb: 0 }}
                    />
                  )}
                  {column.label && !column.editable && column.label}
                  {column.isSelect && (
                    <FieldA
                      field={column.field}
                      data={column.data}
                      onChange={column.onChange}
                      state={column.state}
                      sxx={{ mb: 0, }}
                    />
                  )}
                </TableCell>
              ))}
              {Array.isArray(actions) && (
                <TableCell padding="checkbox" key={"actions-head"}
                  sx={{
                    position: "sticky",
                    right: 0,
                    zIndex: 3,
                    borderLeft: "2px solid black",
                    backgroundColor: "white",
                  }}
                >
                  <Typography variant="p" sx={{ fontWeight: "bold" }}>
                    Action
                  </Typography>
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && <TableSkeletonRows numberOfColumns={columns.length} numberOfRows={10} />}
            {!isLoading && data
              // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, r) => {
                let isItemSelected = isSelected(row._id);

                // now we check if the id exist in map
                // this should only be performed if staticSelectedRows is provided
                // meaning its a custom logic for only one table
                if (staticSelectedRows) {
                  isItemSelected = isSelectedInMap(row._id);
                }

                const labelId = `enhanced-table-checkbox-${r}`;
                // console.log(row, 'get row values');
                return (
                  <>
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      // key={r}
                      selected={isItemSelected}
                      onClick={(e) => {
                        handleClick(e, row._id, row);
                      }}
                      sx={{ cursor: "pointer" }}
                      aria-checked={isItemSelected}
                      key={row._id}
                    >
                      {isSelectEnabled == false ? null : (
                        <TableCell padding="checkbox" key={"checkbox"}>
                          <Checkbox
                            color="primary"
                            checked={isItemSelected}
                            inputProps={{
                              "aria-labelledby": labelId,
                            }}
                          />
                        </TableCell>
                      )}

                      {grouped && (
                        <IconButton
                          aria-label="expand row"
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            console.log(opens);
                            opens[r] = !opens[r];
                            setOpens([...opens]);
                          }}
                        >
                          {opens[r] ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </IconButton>
                      )}

                      {columns.map((column, i) => {
                        const value = row[column.id];
                        const { renderType, renderObj } = column;
                        return (
                          <TableCell
                            key={r + "" + i}
                            align={column.align}
                            sx={{ minWidth: column.minWidth }}
                          >
                            {renderType === "array-select" && (
                              <SelectA
                                field={renderObj.field}
                                data={renderObj.data}
                                onChange={renderObj.onChange}
                                index={r}
                                value={
                                  renderObj.format
                                    ? renderObj.format(value)
                                    : value
                                }
                                sxx={renderObj.sxx}
                              />
                            )}
                            {renderType === "number" && (
                              <NumberFieldA
                                field={renderObj.field}
                                data={renderObj.data}
                                onChange={renderObj.onChange}
                                index={r}
                                value={
                                  renderObj.format
                                    ? renderObj.format(value)
                                    : value
                                }
                                sxx={renderObj.sxx}
                              />
                            )}
                            {renderType === "date" && (
                              <DatePickerA
                                field={renderObj.field}
                                data={renderObj.data}
                                onChange={renderObj.onChange}
                                index={r}
                                value={
                                  renderObj.format
                                    ? renderObj.format(value)
                                    : value
                                }
                                sxx={renderObj.sxx}
                              />
                            )}
                            {!renderType && (
                              <>
                                {column.format
                                  ? column.format(value, row, r, map)
                                  : value || "NA"}
                              </>
                            )}
                          </TableCell>
                        );
                      })}
                      {Array.isArray(actions) && (
                        <TableCell padding="checkbox" key={"actions"}
                          sx={{
                            position: "sticky",
                            right: 0,
                            zIndex: 2,
                            borderLeft: "2px solid black",
                            backgroundColor: "white",
                          }}
                        >
                          <Box sx={{
                            display: "flex",
                            flexDirection: {
                              xs: "column",
                              md: "row",
                            },
                            gap: 1,
                          }}>
                            {actions
                              .filter((c) => !c.hide)
                              .filter((action) => {
                                let show = true;
                                const { showIf, showFunction } = action;
                                if (showIf) {
                                  show = showIf.values.includes(
                                    row[showIf.key],
                                  );
                                }
                                if (show && showFunction) {
                                  show = showFunction(row);
                                }
                                return show;
                              })
                              .map((action, i) => {
                                return (
                                  <>
                                    {action.new && (
                                      <Button
                                        variant="outlined"
                                        size="small"
                                        key={i}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          action.onClick(r);
                                        }}
                                      >
                                        {action.name}
                                      </Button>
                                    )}
                                    {!action.new && (
                                      <Button
                                        key={i}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          action.onClick(r);
                                        }}
                                      >
                                        {action.name}
                                      </Button>
                                    )}
                                  </>
                                );
                              })}
                          </Box>
                        </TableCell>
                      )}
                    </TableRow>
                    {grouped && (
                      <TableRow>
                        <TableCell
                          style={{ paddingBottom: 0, paddingTop: 0 }}
                          colSpan={6}
                        >
                          <Collapse in={opens[r]} timeout="auto" unmountOnExit>
                            <Box sx={{
                              // marginLeft: 5,
                              background: 'aliceblue'
                            }}>
                              <Typography
                                variant="h6"
                                gutterBottom
                                component="div"
                              >
                                History
                              </Typography>
                              <Table size="small" aria-label="purchases">
                                {/* <TableHead>
                                <TableRow>
                                  <TableCell>Date</TableCell>
                                  <TableCell>Customer</TableCell>
                                  <TableCell align="right">Amount</TableCell>
                                  <TableCell align="right">Total price ($)</TableCell>
                                </TableRow>
                              </TableHead> */}
                                <TableBody>
                                  {row.listArray.map((historyRow, j) => (
                                    <TableRow key={j}>
                                      {groupedColumns.map((column, ii) => {
                                        const val = historyRow[column.id];
                                        // Here if the column.render method is defined then in the value we called the column.render and pass in the
                                        // val property to it
                                        return (
                                          <TableCell
                                            component="th"
                                            scope="row"
                                            key={ii}
                                            sx={{
                                              borderRight: 1,
                                              borderColor: "divider",
                                              "&:last-child": {
                                                borderRight: 0,
                                              },
                                              ...(column.sx
                                                ? { ...column.sx }
                                                : {}),
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Typography
                                                variant="subtitle2"
                                                sx={{
                                                  fontWeight: "bold",
                                                  mr: 1,
                                                  color: "text.secondary",
                                                }}
                                              >
                                                {column.id}:
                                              </Typography>
                                              <Typography variant="body2">
                                                {column.render
                                                  ? column.render(val)
                                                  : column.type === "date"
                                                    ? val
                                                      ? dayjs(val).format("DD-MM-YYYY")
                                                      : "NA"
                                                    : val || "NA"}
                                              </Typography>
                                            </Box>
                                          </TableCell>
                                        );
                                        // Check what i am saying, i am providing a column.render method than instead of rending the val we call the column.render(val) method. AI!
                                      })}
                                      {/* columns.map((column, ii) => {
                                        const val = historyRow[column.id];
                                        return (
                                          <TableCell
                                            component="th"
                                            scope="row"
                                            key={ii}
                                          >
                                            {column.id}:{val}
                                          </TableCell>
                                        );
                                      })
*/}
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    )}
                  </>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      {pagination && data.length > 0 && (
        <TablePagination
          // sx={{alignItems:'center'}}
          rowsPerPageOptions={rowsPerPageOptions}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          labelRowsPerPage="Per page"
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </Paper>
  );
};
